// Contains-check patterns (used to flag message content)
export const containsEmailRegExp =
  /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([\sa-zA-Z\-0-9]+\.)+[\sa-zA-Z]{2,}))/;
export const containsTelephoneRegExp =
  /(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?/;
export const containsTelephoneRegExp2 = /[0-9\s\-]{6,40}/;
export const containsUrlRegExp =
  /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/;
export const containsUrlRegExp2 = /\b(dot com|dotcom|www)\b/i;
export const containsContactRegExp = /\b(call me|email me|call|email)\b/i;
export const containsMoneyRegExp = /\b(pound|quid|tenner|fiver|pounds)\b/i;
export const containsMoneyRegExp2 = /^.*[£].*$/;
export const containsProfanityRegExp =
  /\b(fuck|cunt|twat|bitch|arsehole|wanker|shit|bastard|bollocks|cock|dickhead|tosser|wanker|prick|fucking|twat)\b/i;

// Form field validation patterns
export const usernameRegExp =
  /^[A-Za-z0-9\.\£\+\-\(\)\{\}\[\]\,\;\:\'\"\*\^\%\@\!\?\=\~\/\_\$\^\%\ ]{3,20}$/;
export const licenceRegExp = /^[A-Za-z0-9_\.\-]{8,24}$/;
export const genericLicenceRegExp = /^[A-Za-z0-9\_\-]{6,20}$/;
export const otpRegExp = /^[A-Za-z0-9\_\-]{6}$/;
export const nameRegExp = /^[A-Za-z ]{3,20}$/;
export const companyNameRegExp =
  /^[A-Za-z\.\£\+\-\(\)\{\}\[\]\,\;\:\'\"\*\^\%\@\!\?\=\~\/\_\$\^\%\ ]{3,30}$/;
export const jobNameRegExp = /^[A-Za-z0-9\.\?\-\£\+\/!@$%\.\ ,'&*()_]{0,40}$/;
export const dobRegExp = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
export const telephoneRegExp =
  /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
export const emailRegExp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const passwordRegExp =
  /^[A-Za-z0-9\.\£\+\-\(\)\{\}\[\]\,\;\:\'\"\*\^\%\@\!\?\=\~\/\_\$\^\%]{6,20}$/;
export const termsRegExp = /^true$/;
export const pushnotificationsRegExp = /^true|false$/;
export const dateRegExp = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
export const timeRegExp = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
export const shortcopyRegExp =
  /^[A-Za-z0-9\.\£\+\-\(\)\{\}\[\]\,\;\:\'\"\*\^\%\@\!\?\=\~\/\_\$\^\%\ ]{0,50}$/;
export const longcopyRegExp =
  /^[A-Za-z0-9\.\£\+\-\(\)\{\}\[\]\,\;\:\'\"\*\^\%\@\!\?\=\~\/\_\$\^\%\ \r\n|\r|\n,`‘’“”]{0,500}$/;
export const objectidRegExp = /^[a-f\d]{24}$/i;
export const shortidRegExp = /^[A-Za-z0-9\d]{7,14}$/i;
export const priceRegExp = /^\d[\d\,\.]+$/;
export const searchRegExp = /^[A-Za-z0-9\,\_\-\:\.\;]{1,50}$/;
export const pageRegExp = /^[0-9,_]{1,10}$/;
export const creditcardRegExp = /^[0-9]{16}$/;
export const cvcRegExp = /^[0-9]{3}$/;
